// src/components/charts/TopGeolocations.jsx
'use client';

import { useState } from 'react';
import { Card, CardContent, Typography, Stack, Divider, Box, Button, CircularProgress } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { useLanguage } from '../../../utils/i18n';
import VehLocDialog from './VehLocDialog';

const PRIMARY = '#485D9A';
const ACCENT = '#7309B8';

export default function TopGeolocations({ inGeolocation = 0, inGeoVehicles = [], topPools = [], onRefresh, loading }) {
  const { t } = useLanguage();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedStat, setSelectedStat] = useState(null);

  const handleShowAll = () => {
    setSelectedStat({ title: t('dashboardMain.vehicleInGeolocations', 'Vehicles in Geolocation'), dataObj: { vehicles: inGeoVehicles } });
    setDialogOpen(true);
  };

  const handlePoolClick = (poolName, vehicles) => {
    setSelectedStat({ title: poolName, dataObj: { vehicles } });
    setDialogOpen(true);
  };
  return (
    <Box sx={{ display: 'flex', gap: 3 }}>
      {/* Kendaraan Dalam Geolokasi */}
      <Card sx={{ borderRadius: 2, boxShadow: 3, width: 0.3 }}>
        <CardContent sx={{ textAlign: 'center', py: 4 }}>
          <Typography variant="h4" fontWeight={600}>
            {t('dashboardMain.vehicleInGeolocations', 'Vehicles in Geolocation')}
          </Typography>

          <Typography
            variant="h2"
            component="div"
            fontWeight={700}
            sx={{ my: 2, display: 'flex', justifyContent: 'center', alignItems: 'center' }}
          >
            {loading ? <CircularProgress color="inherit" /> : inGeolocation}
          </Typography>

          <Button variant="contained" sx={{ borderRadius: 2, bgcolor: PRIMARY }} onClick={handleShowAll}>
            {t('general.showAll', 'Show All')}
          </Button>
        </CardContent>
      </Card>

      {/* Top 5 Pool Terpadat */}
      <Card sx={{ borderRadius: 2, boxShadow: 3, width: 0.7 }}>
        <CardContent>
          <Typography variant="h4" fontWeight={600}>
            {t('dashboardMain.topGeolocations', ' Top 5 Most Populous Geolocations')}
          </Typography>

          <Box sx={{ mt: 2 }}>
            {topPools.length === 0 && <Typography variant="body2">{t('workOrder.dataNotFound', 'Data not found')}</Typography>}

            {topPools.map((p, i) => (
              <Box key={i}>
                <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ py: 1, borderBottom: 1 }}>
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <LocationOnIcon sx={{ color: PRIMARY }} />
                    <Typography>{p.pool}</Typography>
                  </Stack>

                  <Typography
                    sx={{ color: ACCENT, cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}
                    onClick={() => handlePoolClick(p.pool, p.vehicles)}
                  >
                    {p.jumlah} Kendaraan
                  </Typography>
                </Stack>

                {i < topPools.length - 1 && <Divider />}
              </Box>
            ))}
          </Box>
        </CardContent>
      </Card>

      <VehLocDialog open={dialogOpen} onClose={() => setDialogOpen(false)} selectedStat={selectedStat} />
    </Box>
  );
}
